import React, { useState, useEffect } from 'react';
import {IconButton} from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import Swal from 'sweetalert2';
import {addRecognitionsAndApprovals, updateRecognitionsAndApprovals, deleteRecognitionsAndApprovals } from '../../services/getAdminApi';
import '../../styles/AdminGeneral.css';
import { getRecognitionsAndApprovals} from '../../services/getAllApi'

const RecognitionandApprovals = () => {

    const [items, setItems] = useState([]);
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        image: null,
    });
    const [fileName, setFileName] = useState('');
    const [editingId, setEditingId] = useState(null);

    const fetchItems = async () => {
        try {
            const response = await getRecognitionsAndApprovals();
           
            setItems(Array.isArray(response.data) ? response.data : []);
        } catch (error) {
            Swal.fire('Error', 'Failed to fetch data', 'error');
        }
    };

    const handleInputChange = (e) => {
        const { name, value, files } = e.target;

        if (files) {
            setFormData({
                ...formData,
                [name]: files[0],
            });
            setFileName(files[0].name);
        } else {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    const handleSave = async () => {
        if (!formData.title || !formData.description) {
            Swal.fire('Validation Error', 'Please fill all required fields', 'error');
            return;
        }

        const payload = new FormData();
        Object.entries(formData).forEach(([key, value]) => {
            if (value) payload.append(key, value);
        });

        try {
            if (editingId !== null) {
                const confirmEdit = await Swal.fire({
                    title: 'Are you sure?',
                    text: 'Do you want to update this item?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, update it!',
                });

                if (confirmEdit.isConfirmed) {
                    console.log(formData)
                    await updateRecognitionsAndApprovals(editingId, formData).then((res)=>{
                        if(res.status===200){
                            Swal.fire('Success', 'Item updated successfully', 'success');
                        }
                    })
                  
                }
            } else {
          
                await addRecognitionsAndApprovals(formData).then((res)=>{
                 if(res.status===201){
                    Swal.fire('Success', 'Item added successfully', 'success');
                 }
                })
              
            }
            setFormData({
                title: '',
                description: '',
                image: null,
            });
            setFileName('');
            setEditingId(null);
            fetchItems();
        } catch (error) {
            Swal.fire('Error', 'Failed to save item', 'error');
        }
    };

    const handleEdit = (item) => {
        setEditingId(item.id);
        setFormData({
            title: item.title,
            description: item.description,
            image: null,
        });
        setFileName(item.image ? item.image.split('/').pop() : '');
    };

    const handleDelete = async (id) => {
        const confirmDelete = await Swal.fire({
            title: 'Are you sure?',
            text: 'This action will delete the item permanently!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
        });

        if (confirmDelete.isConfirmed) {
            try {
                await deleteRecognitionsAndApprovals(id);
                Swal.fire('Success', 'Item deleted successfully', 'success');
                fetchItems();
            } catch (error) {
                Swal.fire('Error', 'Failed to delete item', 'error');
            }
        }
    };

    useEffect(() => {
        fetchItems();
    }, []);

  return (
    <>
      <div>
            <div className="dashboard-heading-div">
                <p>Manage Recognitions and Approvals</p>
            </div>

            <div className='editing-container'>
                <div>
                    <h2 className='editing-container-heading'>{editingId !== null ? 'Edit Item' : 'Create Item'}</h2>

                    <div className="editing-container-form">
                        <div className='editing-container-input-div'>
                            <label>Title: </label>
                            <input
                                name="title"
                                value={formData.title}
                                onChange={handleInputChange}
                                required
                                placeholder='Enter Title'
                            />
                        </div>

                        <div className='editing-container-input-div'>
                            <label>Description:</label>
                            <textarea
                                name="description"
                                value={formData.description}
                                onChange={handleInputChange}
                                required
                                placeholder='Enter Description'
                            />
                        </div>

                        <div className='editing-container-input-div'>
                            <label>Image:</label>
                            <label htmlFor="file-upload" className="file-upload-btn">
                                <i className='bx bx-cloud-upload'></i>  {fileName || ' Choose File'}
                            </label>
                            <input
                                className="file-upload"
                                id="file-upload"
                                type="file"
                                name="image"
                                accept="image/*"
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                </div>
                <button variant="contained" color="primary" onClick={handleSave}>
                    {editingId !== null ? 'Update' : 'Save'} <i className='bx bx-send'></i>
                </button>
            </div>

            <div className='table-container-registered-items'>
                <table>
                    <thead>
                        <tr>
                            <th>Title</th>
                            <th>Description</th>
                            <th>Image</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((item) => (
                            <tr key={item.id}>
                                <td>{item.title}</td>
                                <td>{item.description}</td>
                                <td>
                                    {item.image && (
                                        <img
                                            src={`${"https://console.fbsedu.in/storage/app/"}/${item.image}`}
                                            alt="Item Image"
                                            style={{ width: 50, height: 50 }}
                                        />
                                    )}
                                </td>
                                <td>
                                    <IconButton color="secondary" onClick={() => handleEdit(item)}>
                                        <Edit />
                                    </IconButton>
                                    <IconButton color="error" onClick={() => handleDelete(item.id)}>
                                        <Delete />
                                    </IconButton>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div></>
  )
}

export default RecognitionandApprovals